/** Hero copy and media — Paper "Brew — Home (final)" → Hero. */

/** The headline up to its rotating last word. */
export const HERO_TITLE_LEAD = 'Agentic email marketing for'

/**
 * Who Brew is for — the headline's last word cycles through these. The
 * design shows only "Founders" (so it stays first: it is the server-rendered
 * word); the rest is a placeholder list pending product sign-off.
 */
export const HERO_ICP_WORDS = [
  'Founders',
  'Marketers',
  'Developers',
  'Agencies',
  'Startups',
] as const

export const HERO_SUBHEAD =
  'Build and send beautiful, on-brand, revenue-driving emails in minutes.'

export const HERO_BRAND_FIELD = {
  label: 'Your brand’s website',
  placeholder: 'Type in your brand’s website',
  invalidMessage: 'Enter your brand’s website, like acme.com',
  /** The button reads "Start free →" (the navbar CTA's label); the arrow is decorative. */
  submit: 'Start free',
} as const

export type HeroAgentId = 'claude' | 'chatgpt' | 'cursor' | 'grok'

/** The "install directly with" chips, in design order. */
export const HERO_AGENTS: ReadonlyArray<{ id: HeroAgentId; name: string }> = [
  { id: 'claude', name: 'Claude' },
  { id: 'chatgpt', name: 'ChatGPT' },
  { id: 'cursor', name: 'Cursor' },
  { id: 'grok', name: 'Grok' },
]

export const HERO_AGENTS_LABEL = 'Use Brew from your AI assistant'

/**
 * The Brew app screenshot on the hero stage: Paper "Brew app — canvas + chat",
 * exported at 2x and cropped to the part the hero shows (the stage cuts it
 * 530px down; its 1px frame is drawn in CSS).
 */
export const HERO_APP_SCREENSHOT = {
  src: '/landing/home/hero/brew-app-canvas-chat.webp',
  width: 1309,
  height: 529,
  alt: 'The Brew workspace: a welcome email on the canvas beside the chat that is writing it',
} as const
